import api from '@utils/api';

export const getChargers = async (params) => {
  try {
    let url = '/chargers';
    if (params && params.parker_id) {
      url = `/chargers/by_parker/${params.parker_id}`;
      delete params.parker_id;
    }
    const response = await api.get(url, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching chargers:', error);
    throw error;
  }
};

export const createCharger = async (chargerData) => {
  try {
    const response = await api.post('/chargers', chargerData);
    return response.data;
  } catch (error) {
    console.error('Error creating charger:', error);
    throw error;
  }
};

export const getSingleCharger = async (id) => {
  try {
    const response = await api.get(`/chargers/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching charger ${id}:`, error);
    throw error;
  }
};

export const updateCharger = async (id, chargerData) => {
  try {
    const response = await api.put(`/chargers/${id}`, chargerData);
    return response.data;
  } catch (error) {
    console.error(`Error updating charger ${id}:`, error);
    throw error;
  }
};

export const deleteCharger = async (id) => {
  try {
    const response = await api.delete(`/chargers/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting charger ${id}:`, error);
    throw error;
  }
};

export const turnOnCharger = async (id, isAdmin = false) => {
  try {
    const response = await api.post(`/chargers/${id}/on`, null, {
      params: { is_admin: isAdmin }
    });
    return response.data;
  } catch (error) {
    console.error(`Error turning on charger ${id}:`, error);
    throw error;
  }
};

export const turnOffCharger = async (id) => {
  try {
    const response = await api.post(`/chargers/${id}/off`);
    return response.data;
  } catch (error) {
    console.error(`Error turning off charger ${id}:`, error);
    throw error;
  }
};

export const getChargerStatus = async (id) => {
  try {
    const response = await api.get(`/chargers/${id}/status`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching status for charger ${id}:`, error);
    throw error;
  }
};

export const rechargeCharger = async (id) => {
  try {
    const response = await api.post(`/chargers/${id}/recharge`);
    return response.data;
  } catch (error) {
    console.error(`Error recharging charger ${id}:`, error);
    throw error;
  }
};

export const getChargersByParker = async (parkerId) => {
  try {
    const response = await api.get(`/chargers/by_parker/${parkerId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching chargers for parker ${parkerId}:`, error);
    throw error;
  }
};

export const getCurrentEnergy = async (id) => {
 try {
   const response = await api.get(`/chargers/${id}/current_energy`);
   return response.data;
 } catch (error) {
   console.error(`Error fetching current energy for charger ${id}:`, error);
   throw error;
 }
};

export const getChargerSummary = async (id) => {
  try {
    const response = await api.get(`/chargers/${id}/summary`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching summary for charger ${id}:`, error);
    throw error;
  }
};

export const getWallboxAdminDetails = async (id) => {
  try {
    const response = await api.get(`/api/admin/chargers/${id}/wallbox/details`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching Wallbox admin details for charger ${id}:`, error);
    throw error;
  }
};

export const updateWallboxDesiredMaxAmperes = async (id, desiredMaxAmperes, applyToProvider = false) => {
  try {
    const response = await api.put(
      `/api/admin/chargers/${id}/wallbox/config`,
      { desired_max_amperes: desiredMaxAmperes },
      { params: { apply_to_provider: applyToProvider } }
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating Wallbox desired_max_amperes for charger ${id}:`, error);
    throw error;
  }
};

export const setChargerVisibility = async (id, isVisible) => {
  try {
    const response = await api.put(`/chargers/${id}/visibility`, { is_visible: isVisible });
    return response.data;
  } catch (error) {
    console.error(`Error updating charger visibility ${id}:`, error);
    throw error;
  }
};
